export interface Organization {
  id: string;
  name: string;
  slug: string;
  domain?: string;
  logo_url?: string;
  primary_color?: string;
  secondary_color?: string;
  subscription_plan: 'free' | 'basic' | 'premium' | 'enterprise';
  max_users: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  // Redes sociales
  instagram?: string;
  x?: string;
  twitch?: string;
  kick?: string;
  tiktok?: string;
  x_user_id?: string;
}

export interface OrganizationMember {
  id: string;
  organization_id: string;
  user_id: string;
  role: 'owner' | 'admin' | 'member' | 'coach' | 'player';
  joined_at: string;
  invited_by?: string;
  organization?: Organization;
}

export interface OrganizationInvitation {
  id: string;
  organization_id: string;
  email: string;
  role: 'admin' | 'member' | 'coach' | 'player';
  status: 'pending' | 'accepted' | 'declined';
  invited_by: string;
  invited_at: string;
  organization?: Organization;
}

export interface UserProfile {
  id: string;
  email: string;
  full_name?: string;
  avatar_url?: string;
  created_at: string;
  updated_at: string;
}

export interface RoleNavigationPermission {
  id: string;
  organization_id: string;
  role: 'admin' | 'member' | 'coach' | 'player';
  navigation_path: string;
  has_access: boolean;
  created_at: string;
  updated_at: string;
  created_by?: string;
}

export interface OrganizationContextType {
  currentOrganization: Organization | null;
  organizations: Organization[];
  userMemberships: OrganizationMember[];
  isLoading: boolean;
  switchOrganization: (organizationId: string) => Promise<void>;
  acceptInvitation: (invitationId: string) => Promise<void>;
  updateOrganization: (id: string, data: Partial<Organization>) => Promise<Organization>;
  inviteUser: (email: string, role: OrganizationMember['role']) => Promise<OrganizationInvitation>;
  getUserProfile: () => Promise<UserProfile | null>;
  hasPermission: (action: string) => boolean;
}

export type OrganizationRole = OrganizationMember['role'];
export type OrganizationPermissions = {
  [key in OrganizationRole]: string[];
};

export const ORGANIZATION_PERMISSIONS: OrganizationPermissions = {
  owner: ['*'], // All permissions
  admin: [
    'organization.update',
    'organization.invite',
    'organization.members.manage',
    'clients.create',
    'clients.update',
    'clients.delete',
    'overlays.create',
    'overlays.update',
    'overlays.delete',
    'quotes.create',
    'quotes.update',
    'quotes.delete',
    'creators.create',
    'creators.update',
    'creators.delete',
    'rosters.create',
    'rosters.update',
    'rosters.delete',
  ],
  member: [
    'clients.view',
    'clients.create',
    'clients.update',
    'overlays.view',
    'overlays.create',
    'overlays.update',
    'campaigns.view',
    'campaigns.create',
    'campaigns.update',
    'quotes.view',
    'quotes.create',
    'quotes.update',
    'creators.view',
    'creators.create',
    'creators.update',
    'rosters.view',
    'rosters.create',
    'rosters.update',
  ],
  coach: [
    'rosters.view',
    'rosters.create',
    'rosters.update',
    'scrims.view',
    'scrims.create',
    'scrims.update',
    'activities.view',
    'activities.create',
    'activities.update',
    'games.view',
  ],
  player: ['dashboard.view', 'scrims.view', 'vods.view'],
};
